import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const baseURL = "https://astros.eu/backend/";
// export const baseURL = "http://localhost:8080/";

// Define a service using a base URL and expected endpoints
export const astrosApi = createApi({
    reducerPath: "astrosApi",
    credentials: "include",
    baseQuery: fetchBaseQuery({
        baseUrl: baseURL,
        credentials: "include",
    }),
    endpoints: (builder) => ({
        sendEmail: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: "",
                body: JSON.stringify(data),
                credentials: "include",
            }),
        }),
        getData: builder.query({
            query: ({ resource, join }) => ({
                method: "GET",
                url: "",
                params: {
                    resource: resource,
                    join: join,
                },
            }),
            credentials: "include",
            providesTags: ["data"],
        }),
        updateResource: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: "",
                body: data,
            }),
            credentials: "include",
            invalidatesTags: ["data"],
        }),
        login: builder.mutation({
            query: (pass) => ({
                method: "POST",
                url: "/",
                body: {
                    resource: "login",
                    password: pass,
                },
                credentials: "include",
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useSendEmailMutation,
    useGetDataQuery,
    useUpdateResourceMutation,
    useLoginMutation,
    useUploadFileMutation,
} = astrosApi;
